import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row"} }

import GoalForm from '@/components/goals/GoalForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { GoalsActions, GoalsState } from '@/stores/goals.store';
import { Goal } from '@/models/goal.model';
import { useEvents, Event } from '@/services/events.composable';
import TranslatedState from '../common/TranslatedState.vue';
import ListFilter from '../common/ListFilter.vue';
import { FilterData } from '@/services/users.service.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalsList',
  setup(__props) {

const store = useStore<ShiftCMSState & { go: GoalsState }>();
const total = computed<number>(() => store.state.go.goalsTotal);
const items = computed<Goal[]>(() => store.state.go.items);
const events = useEvents();

const filterData = ref<FilterData>({
  search: '',
  level: null,
  page: 1,
  count: 25,
  sort: 'id',
  direction: 'asc',
});

const update = () => {
  store.dispatch(GoalsActions.GetGoals);
};

onMounted(() => {
  update();
  events.on(Event.LanguageChanged, update);
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
  events.off(Event.LanguageChanged, update);
});

const editGoal = (_: Event, { item }: { item: Goal }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(GoalForm),
    data: item,
  });
};

const addGoal = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(GoalForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Title', key: 'title', width: '40%' },
  { title: 'Main', key: 'mainCategory.title', width: '15%' },
  { title: 'Sub', key: 'subCategory.title', width: '15%' },
  { title: 'Date', key: 'creationDate', width: '20%' },
  { title: 'State', key: 'translated', width: '10%' },
];

const filter = ref<string>('');
const filterTitle = ref<string>('');
const filteredItems = computed<Goal[]>(() => {
  return items.value.filter((v: Goal) => {
    if (filterTitle.value) {
      return [v.title, v.description]
        .map((s) => s.toLowerCase())
        .join('')
        .includes(filterTitle.value);
    }

    return true;
  });
});

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filter.value = filters.filter;
  filterTitle.value = filters.filterTitle;

  console.log(filters.filter, filters.filterTitle);
}

function updateItemsPerPage(count: number) {
  filterData.value = { ...filterData.value, count };
  update();
}
function updatePage(page: number) {
  filterData.value = { ...filterData.value, page };
  update();
}

function resetPage() {
  filterData.value = { ...filterData.value, page: 1 };
}
function updateSortBy(sorting: { key: string; order: 'asc' | 'desc' }[]) {
  if (sorting.length) {
    const { key, order } = sorting[0];

    filterData.value = { ...filterData.value, sort: key, direction: order };
    resetPage();
    update();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Goals", -1)),
      _createVNode(ListFilter, {
        dense: "",
        options: [],
        onFilter: updateFilter
      }),
      _createVNode(_component_v_data_table_server, {
        density: "compact",
        "onClick:row": editGoal,
        headers: headers,
        items: filteredItems.value,
        hover: "",
        itemsLength: total.value,
        itemsPerPage: filterData.value.count,
        page: filterData.value.page,
        "onUpdate:itemsPerPage": updateItemsPerPage,
        "onUpdate:page": updatePage,
        "onUpdate:sortBy": updateSortBy
      }, {
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM yyyy')), 1)
        ]),
        "item.translated": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TranslatedState, { item: item }, null, 8, ["item"]),
            _cache[0] || (_cache[0] = _createTextVNode("   ")),
            _createVNode(_component_v_tooltip, {
              text: 
              item.published
                ? 'This item is published'
                : 'This item is not published'
            
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_icon, _mergeProps(props, {
                  icon: item.published ? 'mdi-eye-check' : 'mdi-eye-outline',
                  color: item.published ? 'green' : 'red'
                }), null, 16, ["icon", "color"])
              ]),
              _: 2
            }, 1032, ["text"])
          ])
        ]),
        _: 1
      }, 8, ["items", "itemsLength", "itemsPerPage", "page"]),
      _createVNode(_component_v_btn, {
        onClick: addGoal,
        color: "success"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Add Goal")
        ])),
        _: 1
      }),
      _cache[3] || (_cache[3] = _createTextVNode("  "))
    ]),
    _: 1
  }))
}
}

})